module.exports = __webpack_public_path__ + "kp.svg?f6221ee3512d861ee7556062dd1f168d";